export default __webpack_public_path__ + "static/media/acr.e188fab6.svg";